export default __webpack_public_path__ + "static/top-bg-lg-e734ebff24f0afd6da5bdb2c826455e0.png";